import { render, staticRenderFns } from "./Manage-Userdesignation.vue?vue&type=template&id=6d2012d4"
import script from "./Manage-Userdesignation.vue?vue&type=script&lang=js"
export * from "./Manage-Userdesignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports